import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import {Link} from 'gatsby';
import ImageTyped from './ImageTyped';


const Container = styled.div`
    display : flex;
    flex-direction : column;
    justify-items:flex-start;
    padding-bottom : 30px;
    
    width : calc(100% / 3);
    
    @media (min-width : ${brk.S}) and (max-width : ${brk.M}){
        width : 50%;
    }
    
    @media (max-width : ${brk.S}){
        width : 100%;
    }
    
    & div.content{
        width : 100%
        height : auto;
    }
`;

const Description = styled.div`
`;
const Image = styled.div`
    display:block;
    width: 80%;
	height: auto;
	margin: auto;
	border-radius: 100%;
	overflow : hidden;
	max-width : 300px;
	max-height : 300px;
	margin-bottom : 0;
	margin-top : 0;
    
`;



class Worth extends Component {

    render() {
        const {
            block
        } = this.props;

        return (
            <Container >
                <Image>
                    <ImageTyped dataImage={block.images[0]}/>
                </Image>
                <div className={'content'}>
                    <h4>{block.title}</h4>
                    <h5>{block.subtitle}</h5>
                    <Description className={'description'}
                                 dangerouslySetInnerHTML={{__html: block.textContent.childMarkdownRemark.html}}/>
                    <p><Link className={'btn_underline'} to={block.buttonLink}>
                        {block.buttonLabel}
                    </Link></p>
                </div>
            </Container>


        )
    }
}


export default Worth;